import React from "react";

// Tela que o app Android mostra no lugar de cadastro, assinatura e compra de
// creditos (ver utils/appAndroid). Sem link para o site: mandar comprar fora
// tambem conta como venda no app para a Google Play.
const SoNoSite = () => (
  <div
    style={{
      minHeight: "60vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: 24,
      textAlign: "center",
      fontFamily: "inherit",
    }}
  >
    <h2 style={{ margin: "0 0 12px", fontSize: 20 }}>Disponível no site</h2>
    <p style={{ margin: 0, maxWidth: 360, lineHeight: 1.5, opacity: 0.8 }}>
      Planos, assinatura e créditos são gerenciados pelo site do Floow Chat, no navegador do computador ou do celular.
    </p>
  </div>
);

export default SoNoSite;
